//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { createNamespacedHelpers, mapGetters } from 'vuex'
import {
  ACTION_FETCH_AND_SET_AVAILABILITY_RESPONSE,
  ACTION_SET_IS_FETCHING_FOR_AVAILABILITY,
} from '@/scripts/store/eyewear-protection/actions'
import { MOBILE, TABLET } from '@/scripts/constants/media-query'
import { TRUE_LOWERCASE } from '@/scripts/constants/booleans'
import RbEyewearProtectionPanelAndModal from '@/elements/cart/eyewear-protection/rb-eyewear-protection-panel-and-modal.vue'
import wcs from '@/scripts/libs/wcs'
import i18n from '@/scripts/libs/i18n'
import WCSEyewearProtection from '@/scripts/libs/wcs/eyewear-protection'

const { mapActions: mapActionsEyewearProtection, mapGetters: mapGettersEyewearProtection } =
  createNamespacedHelpers('eyewearProtection')

export default {
  name: 'rb-eyewear-protection',

  components: {
    RbEyewearProtectionPanelAndModal,
  },

  props: {
    isInRedemptionFlowCsr: {
      type: String,
      default: '',
    },
    orderItemId: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      areTranslationsLoadedForDesktop: false,
      isOverlayVisible: false,
    }
  },

  computed: {
    ...mapGetters(['cartItems', 'orderId']),
    ...mapGettersEyewearProtection(['availabilityResponse', 'isFetchingForAvailability']),

    areTranslationsLoaded() {
      return this.isMobileOrTablet ? true : this.areTranslationsLoadedForDesktop
    },
    cartItem() {
      return this.cartItems?.find((item) => item.orderItemId === this.orderItemId)
    },
    cartQuantity() {
      return +this.cartItem?.orderItemQuantity
    },
    checkboxTitle() {
      return this.$t('eyewear_protection.checkbox_title')
    },
    checkedOnLandingPage() {
      return this.eyewearProtectionItemAvailability?.eppSelected ? 'checked' : ''
    },
    isMobileOrTablet() {
      return [MOBILE, TABLET].includes(this.$mq)
    },
    isCanada() {
      return wcs.isCanada()
    },
    isCheckboxDisabled() {
      if (this.isInRedemptionFlowCsr === TRUE_LOWERCASE) {
        return true
      }

      return !!this.isFetchingForAvailability
    },
    isQuebecLinkVisible() {
      const { eyewearProtection } = wcs.getStoreConfig()
      return this.isCanada && eyewearProtection?.quebec?.isCartNoticeEnabled
    },
    eyewearProtectionItemAvailability() {
      return this.availabilityResponse?.find(
        (eppItem) => eppItem.prodOrderItemsId === this.orderItemId
      )
    },
    eyewearProtectionCatEntryId() {
      return this.eyewearProtectionItemAvailability?.eppCatentryId
    },
    eyewearProtectionOrderItemId() {
      return this.eyewearProtectionItemAvailability?.eppOrderItemsId
    },
    isVisible() {
      const { eyewearProtection } = wcs.getStoreConfig()

      return (
        eyewearProtection?.isEnabled &&
        !!this.eyewearProtectionItemAvailability?.eppAvailability &&
        this.areTranslationsLoaded
      )
    },
    price() {
      const { currencySymbol } = wcs.getStoreConfig()
      const price = +this.eyewearProtectionItemAvailability?.eppPrice * this.cartQuantity

      return `${currencySymbol}${price}`
    },
  },

  async created() {
    if (this.isMobileOrTablet) {
      return
    }
    await i18n.loadTranslationsBySection('eyewear-protection')
    this.areTranslationsLoadedForDesktop = true
  },

  methods: {
    ...mapActionsEyewearProtection({
      fetchAndSetAvailabilityResponse: ACTION_FETCH_AND_SET_AVAILABILITY_RESPONSE,
      setIsFetchingForAvailability: ACTION_SET_IS_FETCHING_FOR_AVAILABILITY,
    }),

    closeOverlay() {
      this.isOverlayVisible = false
    },
    onDetailsClick() {
      this.isOverlayVisible = true
    },
    async onToggleCheckbox(isChecked) {
      this.setIsFetchingForAvailability(true)
      let response = {}

      if (isChecked) {
        const params = {
          eyewearProtectionCatEntryId: this.eyewearProtectionCatEntryId,
          orderId: this.orderId,
          orderItemId: this.orderItemId,
          quantity: this.cartQuantity,
        }
        response = await WCSEyewearProtection.addEyewearProtectionProduct(params)
      }

      if (!isChecked) {
        const params = {
          orderId: this.orderId,
          orderItemId: this.eyewearProtectionOrderItemId,
        }
        response = await WCSEyewearProtection.removeEyewearProtectionProduct(params)
      }

      if (this.isMobileOrTablet) {
        await WCSEyewearProtection.updateOrderSummaryInMobile()
      }

      if (!this.isMobileOrTablet) {
        WCSEyewearProtection.updateOrderSummaryInDesktop(response.data)
      }

      await this.fetchAndSetAvailabilityResponse(this.orderId)
      this.setIsFetchingForAvailability(false)
    },
  },
}
